export enum TerminalLogDirectionDTO {
  IN = 'IN',
  OUT = 'OUT',
}
